import { Component, EventEmitter, forwardRef, Inject, Injector, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlService } from '../control.service';

@Component({
  selector: 'qm-input-switch[titleMessage]',
  template: `
  <qm-input-title [titleMessage]="titleMessage"></qm-input-title>
  <p-inputSwitch
  [(ngModel)]="controlValue"
  (onChange)="onChangeValue($event)"
  [disabled]="disabled"
  styleClass="mt-2"></p-inputSwitch>
  `,
  styleUrls: ['./qm-input-switch.component.css'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => QmInputSwitchComponent),
        multi: true
    }
]
})
export class QmInputSwitchComponent implements OnInit, ControlValueAccessor {

  controlForm!: FormControl;
  controlValue!: boolean | undefined;
  onChanged = (_val: boolean) => {};
  onTouched = () => {}
  disabled = false;

  @Input()
  titleMessage: string = "";

  @Output()
  changeEvent = new EventEmitter<any>();

  constructor(@Inject(Injector) private injector: Injector, public ctrlService: ControlService) {}

  public ngOnInit(): void {
    this.controlForm = this.ctrlService.getControlType(this.injector);
  }

  writeValue(val: boolean): void {
    this.controlValue = val;
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onModelChange(event: any) {
    this.onChanged(event);
  }

  onChangeValue(event: any) {
    this.onTouched();
    this.onChanged(event.checked);
    this.changeEvent.emit(event);
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

}
